import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadCloud, Image as ImageIcon, AlertCircle } from 'lucide-react';
import './ImageUploader.css';

const ImageUploader = ({ onUpload, disabled }) => {
    
    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles?.length > 0) {
            onUpload(acceptedFiles[0]);
        }
    }, [onUpload]);

    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        onDrop,
        accept: {
            'image/jpeg': [],
            'image/png': [],
            'image/webp': []
        },
        maxFiles: 1,
        disabled: disabled,
        maxSize: 10485760 // 10MB
    });

    return (
        <div 
            {...getRootProps()} 
            className={`uploader-box ${isDragActive ? 'active' : ''} ${isDragReject ? 'reject' : ''}`}
        >
            <input {...getInputProps()} />
            
            <div className="uploader-content">
                <div className={`icon-circle-upload ${isDragActive ? 'pulse' : ''}`}>
                    {isDragReject ? <AlertCircle size={32} /> : <UploadCloud size={32} />}
                </div>
                
                <div className="uploader-text">
                    {isDragActive ? (
                        <h4>Drop image here...</h4>
                    ) : (
                        <>
                            <h4>Click or Drag Image</h4>
                            <p>JPG, PNG, WebP up to 10MB</p>
                        </>
                    )}
                </div>
                
                <button className="btn-browse-mini">Browse Files</button>
            </div>
        </div>
    );
};

export default ImageUploader;